import Alert from '@mui/material/Alert';
import { useAnnouncement } from '../modules/datastores/useAnnouncement';
import { useEffect, useState } from 'react';
import { Loader } from 'packages/workspace/design/widgets/ui/Loader';

const Announcement = () => {
  const { data } = useAnnouncement();
  const [showAnnouncement, setShowAnnouncement] = useState(true);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    if (data) {
      setIsLoading(false);
    }
  }, [data]);

  return isLoading ? <Loader />
    : <div>
      {showAnnouncement &&
        data &&
        data?.length > 0 &&
        data.map((item, index) => (
          <Alert key={index} variant="filled" severity="warning" onClose={() => setShowAnnouncement(false)}>
            {item.message}
          </Alert>
        ))}
    </div>
}

export default Announcement;
